import { RawClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { clientConfiguration as baseClientConfiguration } from "@common/configuration/environment.base";

export const clientConfiguration: Partial<RawClientConfiguration> = Object.assign({}, baseClientConfiguration, {
    AdaptProjectName: "Nimbus",
    SentryDsn: "https://1aec44093dee43bd96915be0b69c675d@sentry.io/271531",
} as Partial<RawClientConfiguration>);
